import React from 'react'
import { Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'


export default function CustomSkelton(){
    return (
        <Grid container spacing={3}>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
            <Grid item md={2} xs={6}>
                <div>
                    <Skeleton variant="rect" width="80%" height={100} />
                    <Skeleton variant="text" width="80%" />
                </div>
            </Grid>
          
        </Grid>
    )
}